/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcCore from "@grapecity/wijmo"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
// import { useDispatch } from "react-redux"
import dayjs from "dayjs"
import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
// import { AppDispatch } from "../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
// import ConfirmModal from "../../components/ConfirmModal"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import SyainService from "../../../service/master/syain/syainService"
import {
  TSyainInfoGetRes,
  TSyainListGetReq,
} from "../../../service/master/syain/TSyain"

import { 区分分類コード, 社員_乗務員 } from "../../../constant/enum/codes"
import {
  マスタ管理メニューコード,
  メニューコード,
} from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../type/wijmoComponents"
import BusyoService from "../../../service/master/busyo/busyoService"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import { RootState } from "../../../globalStore/rootreducer"
import KubunService from "../../../service/master/kubun/kubunService"
import VALIDATE_CONSTANT from "../../../constant/validateConstant"
import commonUtil from "../../../ts/util/commonUtil"
import dateUtil from "../../../ts/util/dateUtil"
import MonthInput from "../../../components/InputWrapper/MonthInput"

//#region [type]

// DefaultCombo
export type TItem = { name: string; value: any }
const boolList: TItem[] = [
  {
    name: "在籍",
    value: "0",
  },
  {
    name: "退職",
    value: "1",
  },
]

// #endregion

/**
 * 社員マスタ一覧
 * @returns
 */
const MasterSyainList = () => {
  const history = useHistory()
  const location = useLocation()

  const 営業日 = useSelector((state: RootState) => state.date.eigyobiStr)
  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.マスタ管理.社員マスタ
      )?.読み取り専用フラグ
  )

  //TODO:ページ名称確定必須
  let gridId = "MasterSyainList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        年齢: (item: TSyainInfoGetRes) => {
          const today = dayjs(営業日)
          return item.生年月日 ? today.diff(item.生年月日, "year") : undefined
        },
        在籍年数: (item: TSyainInfoGetRes) => {
          return dateUtil.to在籍年月数Str(
            営業日,
            item.入社年月日,
            item.退職年月日
          )
        },
        sort_社員コード: (i: TSyainInfoGetRes) =>
          commonUtil.createSortString(
            i.社員コード,
            VALIDATE_CONSTANT.LENGTH.社員コード
          ),
      },

      sortDescriptions: [new wjcCore.SortDescription("sort_社員コード", true)],

      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyainListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TSyainListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyainService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyainListGetReq = queryString.parse(location.search)
    set部所コード(query.部所コード ?? "")
    set社員区分コード(query.社員区分コード ?? "")
    set社員コード(query.社員コード)
    set社員氏名(query.社員氏名)
    set社員氏名カナ(query.社員氏名カナ)
    set退職フラグ(query.退職フラグ != null ? query.退職フラグ.toString() : "")
    set年月(query.年月)

    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyainListGetReq => {
    return {
      部所コード: 部所コード ?? "",
      社員区分コード: 社員区分コード ?? "",
      社員コード,
      社員氏名,
      社員氏名カナ,
      年月: 年月 ?? "",
      退職フラグ:
        退職フラグ != null && !wjcCore.isNullOrWhiteSpace(退職フラグ)
          ? parseInt(退職フラグ)
          : undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (searchCondition: TSyainListGetReq) => {
    return {
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所略称,
      社員区分: 区分ItemSource?.find(
        (i) =>
          i.区分コード === searchCondition.社員区分コード &&
          i.分類コード === 社員_乗務員.社員区分
      )?.名称1,
      社員CD: wjCore.isNullOrWhiteSpace(searchCondition.社員コード ?? "")
        ? ""
        : searchCondition.社員コード,
      社員氏名: wjCore.isNullOrWhiteSpace(searchCondition.社員氏名 ?? "")
        ? ""
        : searchCondition.社員氏名,
      退職: boolList?.find(
        (i) => i.value === searchCondition.退職フラグ?.toString()
      )?.name,
      年月:
        searchCondition.年月 != null &&
        dayjs(searchCondition.年月).isValid() &&
        dayjs(searchCondition.年月).format("YYYY/MM"),
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set部所コード("")
    set社員区分コード("")
    set社員コード("")
    set社員氏名("")
    set社員氏名カナ("")
    set退職フラグ("0")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // ComboBox制御
  const [comboDataInitialized, setComboDataInitialized] =
    useState<boolean>(false)

  //#endregion

  //#region [state]
  const [部所コード, set部所コード] = useState<string | null>(null)
  const [社員区分コード, set社員区分コード] = useState<string | null>(null)
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()
  const [社員氏名カナ, set社員氏名カナ] = useState<string>()
  const [年月, set年月] = useState<string | null>()
  const [退職フラグ, set退職フラグ] = useState<string | null>("0")

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  //#region [comboboxState]
  // 社員区分
  const [社員区分ComboBox, set社員区分ComboBox] = useState<TWijmoComboBox<
    string,
    T区分マスタ
  > | null>(null)
  const [社員区分IsLoadEnded, set社員区分IsLoadEnded] = useState<boolean>(false)

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // 退職フラグ
  const [退職フラグComboBox, set退職フラグComboBox] = useState<TWijmoComboBox<
    number,
    TItem
  > | null>(null)
  const [退職フラグIsLoadEnded, set退職フラグIsLoadEnded] =
    useState<boolean>(false)
  const [退職フラグItemSource, set退職フラグItemSource] = useState<TItem[]>()

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([
      new BusyoService().getList({}),
      new KubunService().getList(),
    ]).then(([部所ListRes, 区分マスタRes]) => {
      set退職フラグItemSource(boolList)
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      set退職フラグ("0")
    })
  }, [])

  useEffect(() => {
    if (!部所IsLoadEnded || !社員区分IsLoadEnded || !退職フラグIsLoadEnded)
      return

    setComboDataInitialized(true)
  }, [部所IsLoadEnded, 社員区分IsLoadEnded, 退職フラグIsLoadEnded])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized && comboDataInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized, comboDataInitialized])

  useEffect(() => {
    document.title = `社員マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">社員マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                value={年月}
                                // defaultValue={営業日}
                                setValue={set年月}
                                placeholder="年月"
                                autoFocus={true}
                              />
                            </div>
                            <ComboBox.Busyo
                              autoFocus={true}
                              placeholder="部所"
                              isAllSelect={true}
                              itemsSource={部所ItemSource}
                              isLoadEnded={部所IsLoadEnded}
                              setIsLoadEnded={set部所IsLoadEnded}
                              selectedValue={部所コード}
                              setSelectedValue={set部所コード}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>

                            <div className="input-group">
                              <TextInput
                                id="社員番号"
                                name="社員番号"
                                value={社員コード}
                                setValue={set社員コード}
                                maxLength={4}
                                placeholder="社員CD"
                                style={{ width: "6rem" }}
                              />
                              <TextInput
                                id="氏名"
                                name="氏名"
                                value={社員氏名}
                                setValue={set社員氏名}
                                maxLength={100}
                                placeholder="氏名"
                              />
                            </div>
                            <ComboBox.Default
                              className="max-w-10rem"
                              placeholder="退職"
                              isDisabled={年月 != null}
                              isAllSelect={true}
                              itemsSource={退職フラグItemSource}
                              selectedValue={退職フラグ}
                              setSelectedValue={set退職フラグ}
                              isLoadEnded={退職フラグIsLoadEnded}
                              setIsLoadEnded={set退職フラグIsLoadEnded}
                              ComboBox={退職フラグComboBox}
                              setComboBox={
                                set退職フラグComboBox
                              }></ComboBox.Default>
                          </div>
                          <div className="search-condition-row">
                            <div className="w-8rem"></div>
                            <ComboBox.Kubun
                              placeholder="社員区分"
                              分類コード={区分分類コード.社員_乗務員.社員区分}
                              isAllSelect={true}
                              itemsSource={区分ItemSource}
                              selectedValue={社員区分コード}
                              setSelectedValue={set社員区分コード}
                              isLoadEnded={社員区分IsLoadEnded}
                              setIsLoadEnded={set社員区分IsLoadEnded}
                              ComboBox={社員区分ComboBox}
                              setComboBox={
                                set社員区分ComboBox
                              }></ComboBox.Kubun>
                            {/* <div className="input-group"> */}
                            <TextInput
                              className="w-20rem"
                              id="カナ"
                              name="カナ"
                              value={社員氏名カナ}
                              setValue={set社員氏名カナ}
                              maxLength={100}
                              placeholder="カナ"
                            />
                            {/* </div> */}
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                            {年月 != null && (
                              <span className="my-auto ms-1 text-danger fw-bold">
                                年月を指定した場合、当時の在籍者が表示されます。
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <>
                    {!読取専用フラグ && (
                      <Link
                        to={
                          util.getMenuPath(
                            マスタ管理メニューコード.社員マスタ登録
                          )[0]
                        }
                        onClick={() =>
                          gridPageHelper.savePageConditionData(
                            location.pathname
                          )
                        }>
                        <Button disabled={isSearching}>
                          <FontAwesomeIcon icon={faPlusSquare} />
                          新規追加
                        </Button>
                      </Link>
                    )}
                  </>
                }>
                <wjrGrid.FlexGridColumn
                  header=" "
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyainInfoGetRes>
                    ) => {
                      // 社員登録
                      const url = util.getMenuPath(
                        マスタ管理メニューコード.社員マスタ登録
                      )[1]

                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            //TODO: 受け渡すパラメータ確定後修正
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.社員ID.toString()
                              )
                            )
                          }}>
                          {!読取専用フラグ ? "編集" : "参照"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員コード"
                  width={80}
                  sortMemberPath="sort_社員コード"
                  header="社員CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名"
                  width={128}
                  header="氏名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員氏名カナ"
                  width={128}
                  header="氏名カナ"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={180}
                  header="所属部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員区分名称1"
                  width={120}
                  header="社員区分"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="性別区分名称1"
                  width={60}
                  header="性別"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="生年月日"
                  width={100}
                  header="生年月日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyainInfoGetRes>
                    ) => {
                      let dDate = ""
                      if (context.item.生年月日)
                        dDate = dayjs(context.item.生年月日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年齢"
                  width={60}
                  dataType={wjCore.DataType.Number}
                  header="年齢">
                  <wjrGrid.FlexGridCellTemplate
                    cellType={wjrGrid.CellTemplateType.Cell}
                    template={(
                      context: TWijmoCellTemplateContext<TSyainInfoGetRes>
                    ) =>
                      context.item.年齢 != null ? (
                        <span>{context.item.年齢}歳</span>
                      ) : (
                        <></>
                      )
                    }
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="血液型区分名称1"
                  width={80}
                  header="血液型"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="入社年月日"
                  width={100}
                  header="入社日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyainInfoGetRes>
                    ) => {
                      let dDate = ""
                      if (context.item.入社年月日)
                        dDate = dayjs(context.item.入社年月日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="有休付与基準年月日"
                  width={100}
                  header="有休起算日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyainInfoGetRes>
                    ) => {
                      let dDate = ""
                      if (context.item.有休付与基準年月日)
                        dDate = dayjs(context.item.有休付与基準年月日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="在籍年数"
                  width={100}
                  align={"right"}
                  header="在籍年数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="郵便番号"
                  width={90}
                  header="郵便番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="住所"
                  width={250}
                  header="住所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="電話番号"
                  width={140}
                  header="電話番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="携帯電話番号"
                  width={140}
                  header="携帯番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="社員カードID"
                  width={200}
                  header="社員カードID"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備考"
                  width={250}
                  header="備考"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="退職年月日"
                  width={100}
                  header="退職日">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TSyainInfoGetRes>
                    ) => {
                      let dDate = ""
                      if (context.item.退職年月日)
                        dDate = dayjs(context.item.退職年月日).format(
                          "YYYY/MM/DD"
                        )

                      return (
                        <>
                          <span>{dDate}</span>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ESTRA社員コード"
                  width={150}
                  header="ESTRA社員コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="光英社員コード"
                  width={150}
                  header="光英社員コード"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default MasterSyainList

//#region  ダミーデータ

//#endregion
